import realpageRaulLibraryGlobalScript from '/azp/_work/1/s/node_modules/@realpage/raul-library/dist/collection/global/index.js';
import csFeeDisclosureWcGlobalScript from '/azp/_work/1/s/src/app.ts';
export const globalScripts = () => {
  csFeeDisclosureWcGlobalScript();
  realpageRaulLibraryGlobalScript();
};
